/* eslint-disable */
import Highcharts from 'highcharts/highcharts.js';
import { formatAccountingNumber, parseMoney, percentRounded } from '../utils/index';
const axisFormat = (format, num) => {
    switch (format) {
        case 'percent':
            return `${Highcharts.numberFormat((num * 100), 0, '', ',')}%`;
        case 'decimal':
            return Highcharts.numberFormat(num, 0);
        case 'ratio':
            return `${Highcharts.numberFormat(num, 0, '.', ',')}:1`;
        case 'money':
            if (Math.abs(num) >= 1000000) {
                return num >= 0 ? `$${Highcharts.numberFormat(num / 1000000, 0)}M` : `-$${Highcharts.numberFormat(Math.abs(num / 1000000), 0)}M`;
            } else {
                return num >= 0 ? `$${Highcharts.numberFormat(num / 1000, 0)}K` : `-$${Highcharts.numberFormat(Math.abs(num / 1000), 0)}K`;
            }
        case 'wholeNumber':
            return Math.round(num)
    }
}

const surplusToGRIF000s = (calcs, years, abbreviation, height = 210) => {
    let youData = [];
    let keysData = {
        you: {
            copy: abbreviation || 'You',
            color: '#01705e',
            type: 'line',
            dataType: 'you'
        },
        peers: {
            copy: 'Peers',
            color: '#05ccff',
            type: 'line',
            dataType: 'avg'
        },
    }

    Object.keys(keysData).forEach((k) => {
        let data = []
        let dataType = keysData[k]['dataType']

        years.forEach(y => {
            let value = calcs?.[dataType]?.[y]?.['surplus_to_grif_ratio']
            data.push(value)
        })



        youData.push({
            color: keysData[k].color,
            name: keysData[k].copy,
            type: keysData[k].type,
            data: data,
            zIndex: 1,
        })
    })

    return {
        accessibility: {
            description: "$Surplus-to-GRIF (000's) Values over the past 5 Years"
        },
        chart: {
            plotBackgroundColor: '#ffffff',
            backgroundColor: '#d9d9d9',
            height: height,
            spacingTop: 5,
            spacingBottom: 5,
            spacingLeft: 10,
            spacingRight: 10
        },
        title: {
            align: 'center',
            verticalAlign: 'top',
            text: "$Surplus-to-GRIF (000's)",
            style: {
                color: '#000000',
                fontWeight: 'bold',
                fontSize: '1.4em'
            },
            margin: 10,
            y: 15
        },
        credits: {
            enabled: false
        },
        exporting: {
            enabled: false,
            allowHTML: true,
            chartOptions: {
                plotOptions: {
                    series: {
                        dataLabels: {
                        enabled: true
                        }
                    }
                }
            }
        },
        navigation: {
        menuItemHoverStyle: {
            background: '#f5f5f5',
            color: '#000000',
        },
        menuItemStyle: {
            padding: '3px 5px',
            fontWeight: 'bold'
        },
        menuStyle: {
            padding: '0',
        }
        },
        xAxis: {
            categories: years,
            // tickInterval: 2,
            startOnTick: true,
            crosshair: {},
            lineColor: 'transparent',
            labels: {
                style: {
                    color: '#000000',
                    fontWeight: 'bold',
                    fontSize: '1em'
                },
                distance: 5
            }
        },
        yAxis: {
            maxPadding: 0.15,
            min: null,
            title: {
                enabled: false
            },
            gridLineWidth: 1,
            labels: {
                formatter: function () {
                    if (this.value) {
                        return parseMoney(this.value, true)
                    } else {
                        return '0%'
                    }
                },
                style: {
                    color: '#000000',
                    fontWeight: 'bold',
                    fontSize: '1em'
                },
                distance: 5
            },
            tickAmount: 7
        },
        tooltip: {
            shared: true,
            formatter: function () {
                if (!this.points || !this.x) return false;
                let tooltipHtml = `<b>${this.x}</b><br/>`; // Add category (x-axis label)
                this.points.forEach(point => {
                    let value = parseMoney(point.y, true);
                    tooltipHtml += `
                    <span style="color:${point.color}">\u25CF</span> 
                    ${point.series.name}: <b>${value}</b><br/>
                    `;
                });
                return tooltipHtml;
            },
            style: { fontSize: '11px' },
        },
        legend: {
            align: 'center',
            verticalAlign: 'bottom',
            layout: 'horizontal',
            padding: 4,
            backgroundColor: '#ffffff',
            symbolRadius: 0,
            symbolPadding: 2,
            itemDistance: 5,
            itemStyle: {
                color: '#000000',
                fontWeight: 'bold',
                fontSize: '0.9em',
                lineHeight: 1
            }
        },
        plotOptions: {
            line: {
                marker: {
                    enabled: false
                },
                dataLabels: {
                    padding: 8,
                    enabled: true,
                    inside: false,
                    formatter: function () {
                        return parseMoney(this.y, true);
                    },
                    style: {
                        fontSize: '1em'
                    }
                },
            }
        },
        series: youData
    }
}

const breakEvenRatio = (calcs, years, abbreviation, metric, title = 'Break-Even Analysis', addNetLoss = false, height = 210) => {
    let youData = [];
    let keysData = null

    if (addNetLoss) {
       keysData = {
            you: {
                copy: abbreviation,
                color: '#01705e',
                type: 'line',
                dataType: 'you',
                key: metric
            },
            peers: {
                copy: 'Peers',
                color: '#05ccff',
                type: 'line',
                dataType: 'avg',
                key: metric
            },
            actual: {
                copy: 'Actual',
                color: '#92d051',
                type: 'line',
                dataType: 'you',
                key: 'net_loss_ratio'
            },
        }

        Object.keys(keysData).forEach((k) => {
            let data = []
            let dataType = keysData[k]['dataType']

            years.forEach(y => {
                let value = calcs?.[dataType]?.[y]?.[keysData[k]['key']]
                data.push(value)
            })



            youData.push({
                color: keysData[k].color,
                name: keysData[k].copy,
                type: keysData[k].type,
                data: data,
                zIndex: 1,
            })
        })
    } else {
        keysData = {
            you: {
                copy: 'Break-Even Loss Ratio',
                color: '#05ccff',
                type: 'line',
                dataType: 'you',
                key: metric
            },
            peers: {
                copy: 'Loss Ratio - Actual',
                color: '#01705e',
                type: 'line',
                dataType: 'you',
                key: 'net_loss_ratio'
            },
        }

        Object.keys(keysData).forEach((k) => {
            let data = []
            let dataType = keysData[k]['dataType']

            years.forEach(y => {
                let value = calcs?.[dataType]?.[y]?.[keysData[k]['key']]
                data.push(value)
            })



            youData.push({
                color: keysData[k].color,
                name: keysData[k].copy,
                type: keysData[k].type,
                data: data,
                zIndex: 1,
            })
        })
    }

    return {
        accessibility: {
            description: 'Break-Even Analysis Values over the past 5 Years'
        },
        chart: {
            plotBackgroundColor: '#ffffff',
            backgroundColor: '#d9d9d9',
            height: height,
            spacingTop: 5,
            spacingBottom: 5,
            spacingLeft: 10,
            spacingRight: 10,
        },
        title: {
            align: 'center',
            verticalAlign: 'top',
            text: 'Break-Even Analysis',
            style: {
                color: '#000000',
                fontWeight: 'bold',
                fontSize: '1.4em'
            },
            margin: 10,
            y: 15
        },
        credits: {
            enabled: false
        },
        exporting: {
            enabled: false,
            allowHTML: true,
            chartOptions: {
                plotOptions: {
                    series: {
                        dataLabels: {
                        enabled: true
                        }
                    }
                }
            }
        },
        navigation: {
        menuItemHoverStyle: {
            background: '#f5f5f5',
            color: '#000000',
        },
        menuItemStyle: {
            padding: '3px 5px',
            fontWeight: 'bold'
        },
        menuStyle: {
            padding: '0',
        }
        },
        xAxis: {
            categories: years,
            // tickInterval: 2,
            startOnTick: true,
            crosshair: {},
            lineColor: 'transparent',
            labels: {
                style: {
                    color: '#000000',
                    fontWeight: 'bold',
                    fontSize: '1em'
                },
                distance: 5
            }
        },
        yAxis: {
            maxPadding: 0.15,
            min: null,
            title: {
                enabled: false
            },
            gridLineWidth: 1,
            labels: {
                formatter: function () {
                    if (this.value) {
                        return percentRounded(this.value, 100)
                    } else {
                        return '0%'
                    }
                },
                style: {
                    color: '#000000',
                    fontWeight: 'bold',
                    fontSize: '1em'
                },
                distance: 5
            },
            tickAmount: 7
        },
        tooltip: {
            shared: true,
            formatter: function () {
                if (!this.points || !this.x) return false;
                let tooltipHtml = `<b>${this.x}</b><br/>`; // Add category (x-axis label)
                this.points.forEach(point => {
                    let value = percentRounded(point.y, 100);
                    tooltipHtml += `
                    <span style="color:${point.color}">\u25CF</span> 
                    ${point.series.name}: <b>${value}</b><br/>
                    `;
                });
                return tooltipHtml;
            },
            style: { fontSize: '11px' },
        },
        legend: {
            align: 'center',
            verticalAlign: 'bottom',
            layout: 'horizontal',
            padding: 4,
            backgroundColor: '#ffffff',
            symbolRadius: 0,
            symbolPadding: 2,
            itemDistance: 5,
            itemStyle: {
                color: '#000000',
                fontWeight: 'bold',
                fontSize: '0.9em',
                lineHeight: 1
            }
        },
        plotOptions: {
            line: {
                marker: {
                    enabled: false
                },
                dataLabels: {
                    allowOverlap: false,
                    enabled: true,
                    inside: false,
                    padding: 8,
                    formatter: function () {
                        return percentRounded(this.y, 100);
                    },
                    style: {
                        fontSize: '1em'
                    }
                },
            }
        },
        series: youData
    }
}

const opexRatio = (calcs, years, abbreviation, title = 'Operating Expense Ratio', height = 210) => {
    let youData = [];
    let keysData = {
        you: {
            copy: abbreviation || 'You',
            color: '#01705e',
            type: 'column',
            dataType: 'you'
        },
        peers: {
            copy: 'Peers',
            color: '#05ccff',
            type: 'line',
            dataType: 'avg'
        },
    }

    Object.keys(keysData).forEach((key) => {
        let data = []
        let dataType = keysData[key]['dataType']

        years.forEach(y => {
            let value = calcs?.[dataType]?.[y]?.['operating_expense_ratio']
            data.push(value)
        })



        youData.push({
            color: keysData[key].color,
            name: keysData[key].copy,
            type: keysData[key].type,
            data: data,
            zIndex: 1,
        })
    })

    return {
        accessibility: {
            description: 'Operating Expense Ratio Values over the past 5 Years'
        },
        chart: {
            plotBackgroundColor: '#ffffff',
            backgroundColor: '#d9d9d9',
            height: height,
            spacingTop: 5,
            spacingBottom: 5,
            spacingLeft: 10,
            spacingRight: 10
        },
        title: {
            align: 'center',
            verticalAlign: 'top',
            text: title,
            style: {
                color: '#000000',
                fontWeight: 'bold',
                fontSize: '1.4em'
            },
            margin: 10,
            y: 15
        },
        credits: {
            enabled: false
        },
        exporting: {
            enabled: false,
            allowHTML: true,
            chartOptions: {
                plotOptions: {
                    series: {
                        dataLabels: {
                            enabled: true
                        }
                    }
                }
            }
        },
        navigation: {
        menuItemHoverStyle: {
            background: '#f5f5f5',
            color: '#000000',
        },
        menuItemStyle: {
            padding: '3px 5px',
            fontWeight: 'bold'
        },
        menuStyle: {
            padding: '0',
        }
        },
        xAxis: {
            categories: years,
            // tickInterval: 2,
            startOnTick: true,
            crosshair: {},
            lineColor: 'transparent',
            labels: {
                style: {
                    color: '#000000',
                    fontWeight: 'bold',
                    fontSize: '1em'
                },
                distance: 5
            }
        },
        yAxis: {
            maxPadding: 0.15,
            min: null,
            title: {
                enabled: false
            },
            gridLineWidth: 1,
            labels: {
                formatter: function () {
                    if (this.value) {
                        return percentRounded(this.value, 100)
                    } else {
                        return '0%'
                    }
                },
                style: {
                    color: '#000000',
                    fontWeight: 'bold',
                    fontSize: '1em'
                },
                distance: 5
            },
            tickAmount: 7
        },
        tooltip: {
            shared: true,
            formatter: function () {
                if (!this.points || !this.x) return false;
                let tooltipHtml = `<b>${this.x}</b><br/>`; // Add category (x-axis label)
                this.points.forEach(point => {
                    let value = percentRounded(point.y, 100);
                    tooltipHtml += `
                    <span style="color:${point.color}">\u25CF</span> 
                    ${point.series.name}: <b>${value}</b><br/>
                    `;
                });
                return tooltipHtml;
            },
            style: { fontSize: '11px' },
        },
        legend: {
            align: 'center',
            verticalAlign: 'bottom',
            layout: 'horizontal',
            padding: 4,
            backgroundColor: '#ffffff',
            symbolRadius: 0,
            symbolPadding: 2,
            itemDistance: 5,
            itemStyle: {
                color: '#000000',
                fontWeight: 'bold',
                fontSize: '0.9em',
                lineHeight: 1
            }
        },
        plotOptions: {
            column: {
                grouping: true,
                dataLabels: {
                    enabled: true,
                    inside: false,
                    crop: false,
                    overflow: 'none',
                    padding: 4,
                    formatter: function () {
                        return percentRounded(this.y, 100);
                    },
                    style: {
                        fontSize: '1em'
                    }
                },
                borderRadius: {
                    radius: '0%',
                },
                pointWidth: 25
            },
            line: {
                marker: {
                    enabled: false
                }
            }
        },
        series: youData
    }
}

const combinedRatio = (calcs, years, abbreviation, metric, title, height = 210) => {
    let youData = [];
    let keysData = {
        you: {
        copy: abbreviation || 'You',
        color: '#01705e',
        type: 'column',
        dataType: 'you'
        },
        peers: {
        copy: 'Peers',
        color: '#05ccff',
        type: 'line',
        dataType: 'avg'
        },
    }

    Object.keys(keysData).forEach((key) => {
        let data = []
        let dataType = keysData[key]['dataType']

        years.forEach(y => {
            let value = calcs?.[dataType]?.[y]?.[metric]
            data.push(value)
        })



        youData.push({
            color: keysData[key].color,
            name: keysData[key].copy,
            type: keysData[key].type,
            data: data,
            zIndex: 1,
        })
    })

    return {
        accessibility: {
            description: `${title} Values over the past 5 Years`
        },
        chart: {
            plotBackgroundColor: '#ffffff',
            backgroundColor: '#d9d9d9',
            height: height,
            spacingTop: 5,
            spacingBottom: 5,
            spacingLeft: 10,
            spacingRight: 10
        },
        title: {
            align: 'center',
            verticalAlign: 'top',
            text: title,
            style: {
                color: '#000000',
                fontWeight: 'bold',
                fontSize: '1.4em'
            },
            margin: 10,
            y: 15
        },
        credits: {
            enabled: false
        },
        exporting: {
            enabled: false,
            allowHTML: true,
            chartOptions: {
                plotOptions: {
                    series: {
                        dataLabels: {
                            enabled: true
                        }
                    }
                }
            }
        },
        navigation: {
        menuItemHoverStyle: {
            background: '#f5f5f5',
            color: '#000000',
        },
        menuItemStyle: {
            padding: '3px 5px',
            fontWeight: 'bold'
        },
        menuStyle: {
            padding: '0',
        }
        },
        xAxis: {
            categories: years,
            // tickInterval: 2,
            startOnTick: true,
            crosshair: {},
            lineColor: 'transparent',
            labels: {
                style: {
                    color: '#000000',
                    fontWeight: 'bold',
                    fontSize: '1em'
                },
                distance: 5
            }
        },
        yAxis: {
            maxPadding: 0.15,
            min: null,
            title: {
                enabled: false
            },
            gridLineWidth: 1,
            labels: {
                formatter: function () {
                    if (this.value) {
                        return percentRounded(this.value, 100)
                    } else {
                        return '0%'
                    }
                },
                style: {
                    color: '#000000',
                    fontWeight: 'bold',
                    fontSize: '1em'
                },
                distance: 5
            },
            tickAmount: 7
        },
        tooltip: {
            shared: true,
            formatter: function () {
                if (!this.points || !this.x) return false;
                let tooltipHtml = `<b>${this.x}</b><br/>`; // Add category (x-axis label)
                this.points.forEach(point => {
                    let value = percentRounded(point.y, 100);
                    tooltipHtml += `
                    <span style="color:${point.color}">\u25CF</span> 
                    ${point.series.name}: <b>${value}</b><br/>
                    `;
                });
                return tooltipHtml;
            },
            style: { fontSize: '11px' },
        },
        legend: {
            align: 'center',
            verticalAlign: 'bottom',
            layout: 'horizontal',
            padding: 4,
            backgroundColor: '#ffffff',
            symbolRadius: 0,
            symbolPadding: 2,
            itemDistance: 5,
            itemStyle: {
                color: '#000000',
                fontWeight: 'bold',
                fontSize: '0.9em',
                lineHeight: 1
            }
        },
        plotOptions: {
            column: {
                grouping: true,
                dataLabels: {
                    enabled: true,
                    inside: false,
                    crop: false,
                    overflow: 'none',
                    padding: 4,
                    formatter: function () {
                        return percentRounded(this.y, 100);
                    },
                    style: {
                        fontSize: '1em'
                    }
                },
                borderRadius: {
                    radius: '0%',
                },
                pointWidth: 25
            },
            line: {
                marker: {
                    enabled: false
                }
            }
        },
        series: youData
    }
}

const liquidityRatio = (calcs, years, abbreviation, addAM = false, height = 210) => {
    let youData = [];
    let keysData = {
        you: {
            copy: abbreviation || 'You',
            color: '#01705e',
            type: 'column',
            dataType: 'you'
        },
        peers: {
            copy: 'Peers',
            color: '#05ccff',
            type: 'line',
            dataType: 'avg'
        },
    }

    Object.keys(keysData).forEach((key) => {
        let data = []
        let dataType = keysData[key]['dataType']

        years.forEach(y => {
            let value = calcs?.[dataType]?.[y]?.['liquidity_ratio']
            data.push(value)
        })

        youData.push({
            color: keysData[key].color,
            name: keysData[key].copy,
            type: keysData[key].type,
            data: data,
            zIndex: 1,
        })
    })

    if (addAM) {
        let data = [1.4, 1.4, 1.4, 1.4, 1.4]

        youData.push({
            color: '#92d051',
            name: 'AM Best - Low',
            type: 'line',
            data: data,
            zIndex: 1,
        })
    }

    return {
        accessibility: {
            description: 'Liquidity Ratio Values over the past 5 Years'
        },
        chart: {
            plotBackgroundColor: '#ffffff',
            backgroundColor: '#d9d9d9',
            height: height,
            spacingTop: 5,
            spacingBottom: 5,
            spacingLeft: 10,
            spacingRight: 10
        },
        title: {
            align: 'center',
            verticalAlign: 'top',
            text: 'Liquidity Ratio',
            style: {
                color: '#000000',
                fontWeight: 'bold',
                fontSize: '1.4em'
            },
            margin: 10,
            y: 15
        },
        credits: {
            enabled: false
        },
        exporting: {
            enabled: false,
            allowHTML: true,
            chartOptions: {
                plotOptions: {
                    series: {
                        dataLabels: {
                        enabled: true
                        }
                    }
                }
            }
        },
        navigation: {
        menuItemHoverStyle: {
            background: '#f5f5f5',
            color: '#000000',
        },
        menuItemStyle: {
            padding: '3px 5px',
            fontWeight: 'bold'
        },
        menuStyle: {
            padding: '0',
        }
        },
        xAxis: {
            categories: years,
            // tickInterval: 2,
            startOnTick: true,
            crosshair: {},
            lineColor: 'transparent',
            labels: {
                style: {
                    color: '#000000',
                    fontWeight: 'bold',
                    fontSize: '1em'
                },
                distance: 5
            }
        },
        yAxis: {
            maxPadding: 0.15,
            min: null,
            title: {
                enabled: false
            },
            gridLineWidth: 1,
            labels: {
                formatter: function () {
                    if (this.value) {
                        return percentRounded(this.value, 100)
                    } else {
                        return '0%'
                    }
                },
                style: {
                    color: '#000000',
                    fontWeight: 'bold',
                    fontSize: '1em'
                },
                distance: 5
            },
            tickAmount: 7
        },
        tooltip: {
            shared: true,
            formatter: function () {
                if (!this.points || !this.x) return false;
                let tooltipHtml = `<b>${this.x}</b><br/>`; // Add category (x-axis label)
                this.points.forEach(point => {
                    let value = percentRounded(point.y, 100);
                    tooltipHtml += `
                    <span style="color:${point.color}">\u25CF</span> 
                    ${point.series.name}: <b>${value}</b><br/>
                    `;
                });
                return tooltipHtml;
            },
            style: { fontSize: '11px' },
        },
        legend: {
            align: 'center',
            verticalAlign: 'bottom',
            layout: 'horizontal',
            padding: 4,
            backgroundColor: '#ffffff',
            symbolRadius: 0,
            symbolPadding: 2,
            itemDistance: 5,
            itemStyle: {
                color: '#000000',
                fontWeight: 'bold',
                fontSize: '0.9em',
                lineHeight: 1
            }
        },
        plotOptions: {
            column: {
                grouping: true,
                dataLabels: {
                    enabled: true,
                    inside: false,
                    crop: false,
                    overflow: 'none',
                    padding: 4,
                    formatter: function () {
                        return percentRounded(this.y, 100);
                    },
                    style: {
                        fontSize: '1em'
                    }
                },
                borderRadius: {
                    radius: '0%',
                },
                pointWidth: 25
            },
            line: {
                marker: {
                    enabled: false
                }
            }
        },
        series: youData
    }
}

const reinsuranceToGPW = (calcs, years, abbreviation, height = 210) => {
    let youData = [];
    let keysData = {
        you: {
            copy: abbreviation || 'You',
            color: '#01705e',
            type: 'column',
            dataType: 'you'
        },
        peers: {
            copy: 'Peers',
            color: '#05ccff',
            type: 'line',
            dataType: 'avg'
        },
    }

    Object.keys(keysData).forEach((key) => {
        let data = []
        let dataType = keysData[key]['dataType']

        years.forEach(y => {
            let value = calcs?.[dataType]?.[y]?.['reinsurance_to_gpw_ratio']
            data.push(value)
        })



        youData.push({
            color: keysData[key].color,
            name: keysData[key].copy,
            type: keysData[key].type,
            data: data,
            zIndex: 1,
        })
    })

    return {
        accessibility: {
            description: '%Reinsurance-to-GPW Ratio Values over the past 5 Years'
        },
        chart: {
            plotBackgroundColor: '#ffffff',
            backgroundColor: '#d9d9d9',
            height: height,
            spacingTop: 5,
            spacingBottom: 5,
            spacingLeft: 10,
            spacingRight: 10
        },
        title: {
            align: 'center',
            verticalAlign: 'top',
            text: '%Reinsurance-to-GPW',
            style: {
                color: '#000000',
                fontWeight: 'bold',
                fontSize: '1.4em'
            },
            margin: 10,
            y: 15
        },
        credits: {
            enabled: false
        },
        exporting: {
            enabled: false,
            allowHTML: true,
            chartOptions: {
                plotOptions: {
                    series: {
                        dataLabels: {
                        enabled: true
                        }
                    }
                }
            }
        },
        navigation: {
        menuItemHoverStyle: {
            background: '#f5f5f5',
            color: '#000000',
        },
        menuItemStyle: {
            padding: '3px 5px',
            fontWeight: 'bold'
        },
        menuStyle: {
            padding: '0',
        }
        },
        xAxis: {
            categories: years,
            // tickInterval: 2,
            startOnTick: true,
            crosshair: {},
            lineColor: 'transparent',
            labels: {
                style: {
                    color: '#000000',
                    fontWeight: 'bold',
                    fontSize: '1em'
                },
                distance: 5
            }
        },
        yAxis: {
            maxPadding: 0.15,
            min: null,
            title: {
                enabled: false
            },
            gridLineWidth: 1,
            labels: {
                formatter: function () {
                    if (this.value) {
                        return percentRounded(this.value, 100)
                    } else {
                        return '0%'
                    }
                },
                style: {
                    color: '#000000',
                    fontWeight: 'bold',
                    fontSize: '1em'
                },
                distance: 5
            },
            tickAmount: 7
        },
        tooltip: {
            shared: true,
            formatter: function () {
                if (!this.points || !this.x) return false;
                let tooltipHtml = `<b>${this.x}</b><br/>`; // Add category (x-axis label)
                this.points.forEach(point => {
                    let value = percentRounded(point.y, 100);
                    tooltipHtml += `
                    <span style="color:${point.color}">\u25CF</span> 
                    ${point.series.name}: <b>${value}</b><br/>
                    `;
                });
                return tooltipHtml;
            },
            style: { fontSize: '11px' },
        },
        legend: {
            align: 'center',
            verticalAlign: 'bottom',
            layout: 'horizontal',
            padding: 4,
            backgroundColor: '#ffffff',
            symbolRadius: 0,
            symbolPadding: 2,
            itemDistance: 5,
            itemStyle: {
                color: '#000000',
                fontWeight: 'bold',
                fontSize: '0.9em',
                lineHeight: 1
            }
        },
        plotOptions: {
            column: {
                grouping: true,
                dataLabels: {
                    enabled: true,
                    inside: false,
                    crop: false,
                    overflow: 'none',
                    padding: 4,
                    formatter: function () {
                        return percentRounded(this.y, 100);
                    },
                    style: {
                        fontSize: '1em'
                    },
                    zIndex: 7
                },
                borderRadius: {
                    radius: '0%',
                },
                pointWidth: 25
            },
            line: {
                marker: {
                    enabled: false
                }
            }
        },
        series: youData
    }
}

const netPremiumWrittenToSurplus = (calcs, years, abbreviation, height = 210) => {
    // let allValues = []
    let youData = [];
    let keysData = {
        you: {
            copy: abbreviation || 'You',
            color: '#01705e',
            type: 'column',
            dataType: 'you'
        },
        peers: {
            copy: 'Peers',
            color: '#05ccff',
            type: 'line',
            dataType: 'avg'
        },
    }

    Object.keys(keysData).forEach((key) => {
        let data = []
        let dataType = keysData[key]['dataType']

        years.forEach(y => {
            let value = calcs?.[dataType]?.[y]?.['net_premium_to_surplus_ratio']
            data.push(value)
        })



        youData.push({
            color: keysData[key].color,
            name: keysData[key].copy,
            type: keysData[key].type,
            data: data,
            zIndex: 1,
        })
    })

    return {
        accessibility: {
            description: 'Net Premium Written-to-Surplus Ratio Values over the past 5 Years'
        },
        chart: {
            plotBackgroundColor: '#ffffff',
            backgroundColor: '#d9d9d9',
            height: height,
            spacingTop: 5,
            spacingBottom: 5,
            spacingLeft: 10,
            spacingRight: 10
        },
        title: {
            align: 'center',
            verticalAlign: 'top',
            text: 'Net Premium Written-to-Surplus',
            style: {
                color: '#000000',
                fontWeight: 'bold',
                fontSize: '1.4em'
            },
            margin: 10,
            y: 15
        },
        credits: {
            enabled: false
        },
        exporting: {
            enabled: false,
            allowHTML: true,
            chartOptions: {
                plotOptions: {
                    series: {
                        dataLabels: {
                        enabled: true
                        }
                    }
                }
            }
        },
        navigation: {
        menuItemHoverStyle: {
            background: '#f5f5f5',
            color: '#000000',
        },
        menuItemStyle: {
            padding: '3px 5px',
            fontWeight: 'bold'
        },
        menuStyle: {
            padding: '0',
        }
        },
        xAxis: {
            categories: years,
            // tickInterval: 2,
            startOnTick: true,
            crosshair: {},
            lineColor: 'transparent',
            labels: {
                style: {
                    color: '#000000',
                    fontWeight: 'bold',
                    fontSize: '1em'
                },
                distance: 5
            }
        },
        yAxis: {
            maxPadding: 0.15,
            min: null,
            title: {
                enabled: false
            },
            gridLineWidth: 1,
            labels: {
                formatter: function () {
                    if (this.value) {
                        return percentRounded(this.value, 100)
                    } else {
                        return '0%'
                    }
                },
                style: {
                    color: '#000000',
                    fontWeight: 'bold',
                    fontSize: '1em'
                },
                distance: 5
            },
            tickAmount: 7
        },
        tooltip: {
            shared: true,
            formatter: function () {
                if (!this.points || !this.x) return false;
                let tooltipHtml = `<b>${this.x}</b><br/>`; // Add category (x-axis label)
                this.points.forEach(point => {
                    let value = percentRounded(point.y, 100);
                    tooltipHtml += `
                    <span style="color:${point.color}">\u25CF</span> 
                    ${point.series.name}: <b>${value}</b><br/>
                    `;
                });
                return tooltipHtml;
            },
            style: { fontSize: '11px' },
        },
        legend: {
            align: 'center',
            verticalAlign: 'bottom',
            layout: 'horizontal',
            padding: 4,
            backgroundColor: '#ffffff',
            symbolRadius: 0,
            symbolPadding: 2,
            itemDistance: 5,
            itemStyle: {
                color: '#000000',
                fontWeight: 'bold',
                fontSize: '0.9em',
                lineHeight: 1
            }
        },
        plotOptions: {
            column: {
                grouping: true,
                dataLabels: {
                    enabled: true,
                    inside: false,
                    crop: false,
                    overflow: 'none',
                    padding: 4,
                    formatter: function () {
                        return percentRounded(this.y, 100);
                    },
                    style: {
                        fontSize: '1em'
                    }
                },
                borderRadius: {
                    radius: '0%',
                },
                pointWidth: 25
            },
            line: {
                marker: {
                    enabled: false
                }
            }
        },
        series: youData
    }
}

const netLeverageRatio = (calcs, years, abbreviation, height = 210) => {
    // let allValues = []
    let youData = [];
    let keysData = {
        you: {
            copy: abbreviation || 'You',
            color: '#01705e',
            type: 'column',
            dataType: 'you'
        },
        peers: {
            copy: 'Peers',
            color: '#05ccff',
            type: 'line',
            dataType: 'avg'
        },
    }

    Object.keys(keysData).forEach((key) => {
        let data = []
        let dataType = keysData[key]['dataType']

        years.forEach(y => {
            let value = calcs?.[dataType]?.[y]?.['net_leverage_ratio']
            data.push(value)
        })



        youData.push({
            color: keysData[key].color,
            name: keysData[key].copy,
            type: keysData[key].type,
            data: data,
            zIndex: 1,
        })
    })

    return {
        accessibility: {
            description: 'Net Leverage Ratio Values over the past 5 years'
        },
        chart: {
            plotBackgroundColor: '#ffffff',
            backgroundColor: '#d9d9d9',
            height: height,
            spacingTop: 5,
            spacingBottom: 5,
            spacingLeft: 10,
            spacingRight: 10
        },
        title: {
            align: 'center',
            verticalAlign: 'top',
            text: 'Net Leverage Ratio',
            style: {
                color: '#000000',
                fontWeight: 'bold',
                fontSize: '1.4em'
            },
            margin: 10,
            y: 15
        },
        credits: {
            enabled: false
        },
        exporting: {
            enabled: false,
            allowHTML: true,
            chartOptions: {
                plotOptions: {
                    series: {
                        dataLabels: {
                        enabled: true
                        }
                    }
                }
            }
        },
        navigation: {
        menuItemHoverStyle: {
            background: '#f5f5f5',
            color: '#000000',
        },
        menuItemStyle: {
            padding: '3px 5px',
            fontWeight: 'bold'
        },
        menuStyle: {
            padding: '0',
        }
        },
        xAxis: {
            categories: years,
            // tickInterval: 2,
            startOnTick: true,
            crosshair: {},
            lineColor: 'transparent',
            labels: {
                style: {
                    color: '#000000',
                    fontWeight: 'bold',
                    fontSize: '1em'
                },
                distance: 5
            }
        },
        yAxis: {
            maxPadding: 0.15,
            min: null,
            title: {
                enabled: false
            },
            gridLineWidth: 1,
            labels: {
                formatter: function () {
                    if (this.value) {
                        return percentRounded(this.value, 100)
                    } else {
                        return '0%'
                    }
                },
                style: {
                    color: '#000000',
                    fontWeight: 'bold',
                    fontSize: '1em'
                },
                distance: 5
            },
            tickAmount: 7
        },
        tooltip: {
            shared: true,
            formatter: function () {
                if (!this.points || !this.x) return false;
                let tooltipHtml = `<b>${this.x}</b><br/>`; // Add category (x-axis label)
                this.points.forEach(point => {
                    let value = percentRounded(point.y, 100);
                    tooltipHtml += `
                    <span style="color:${point.color}">\u25CF</span> 
                    ${point.series.name}: <b>${value}</b><br/>
                    `;
                });
                return tooltipHtml;
            },
            style: { fontSize: '11px' },
        },
        legend: {
            align: 'center',
            verticalAlign: 'bottom',
            layout: 'horizontal',
            padding: 4,
            backgroundColor: '#ffffff',
            symbolRadius: 0,
            symbolPadding: 2,
            itemDistance: 5,
            itemStyle: {
                color: '#000000',
                fontWeight: 'bold',
                fontSize: '0.9em',
                lineHeight: 1
            }
        },
        plotOptions: {
            column: {
                grouping: true,
                dataLabels: {
                    enabled: true,
                    inside: false,
                    crop: false,
                    overflow: 'none',
                    padding: 4,
                    formatter: function () {
                        return percentRounded(this.y, 100);
                    },
                    style: {
                        fontSize: '1em'
                    }
                },
                borderRadius: {
                    radius: '0%',
                },
                pointWidth: 25
            },
            line: {
                marker: {
                    enabled: false
                }
            }
        },
        series: youData
    }
}

const roundAxisMax = (value) => {
  const millions = value / 1000000;
  const whole = Math.floor(millions);
  const fraction = millions - whole;

  const roundedMillions = fraction >= 0.5 ? whole + 1 : whole + 1;

  return roundedMillions * 1000000;
}

const premiumChart = (calcs, years, abbreviation, height = 210) => {

    let allData = [];
    let youData = [];
    let keysData = {
        gross_premium_written: {
            copy: 'Premium Written',
            color: '#005546'
        },
        net_premium_written: {
            copy: 'Net Premium Written',
            color: '#039e5d'
        },
        premium_earned: {
            copy: 'Premium Earned',
            color: '#039ea4'
        },
    }

    Object.keys(keysData).forEach((key) => {
        let data = []
        let total = 0

        years.forEach(y => {
            let value = calcs?.you?.[y]?.[key]
            data.push(value)
            allData.push(value)
        })



        youData.push({
            color: keysData[key].color,
            name: keysData[key].copy,
            type: 'column',
            data: data,
            zIndex: 1,
        })
    })

    const maxValue = Math.max(...allData);
    const yAxisMax = roundAxisMax(maxValue);
    const tickInterval = Math.ceil(yAxisMax / 5 / 1000000) * 1000000;

    return {
        accessibility: {
            description: 'Premium Values over the past 5 Years'
        },
        chart: {
            plotBackgroundColor: '#ffffff',
            backgroundColor: '#d9d9d9',
            height: height,
            spacingTop: 5,
            spacingBottom: 5,
            spacingLeft: 10,
            spacingRight: 10
        },
        title: {
            align: 'center',
            verticalAlign: 'top',
            text: 'Premium',
            style: {
                color: '#000000',
                fontWeight: 'bold',
                fontSize: '1.4em'
            },
            margin: 10,
            y: 15
        },
        credits: {
            enabled: false
        },
        exporting: {
            enabled: false,
            allowHTML: true,
            chartOptions: {
                plotOptions: {
                    series: {
                        dataLabels: {
                        enabled: true
                        }
                    }
                }
            }
        },
        navigation: {
        menuItemHoverStyle: {
            background: '#f5f5f5',
            color: '#000000',
        },
        menuItemStyle: {
            padding: '3px 5px',
            fontWeight: 'bold'
        },
        menuStyle: {
            padding: '0',
        }
        },
        xAxis: {
            categories: years,
            // tickInterval: 2,
            startOnTick: true,
            crosshair: {},
            lineColor: 'transparent',
            labels: {
                style: {
                    color: '#000000',
                    fontWeight: 'bold',
                    fontSize: '1em'
                },
                distance: 5
            }
        },
        yAxis: {
            max: yAxisMax,
            min: null,
            title: {
                enabled: false
            },
            gridLineWidth: 1,
            labels: {
                formatter: function () {
                    if (this.value) {
                        return axisFormat('money', this.value)
                    } else {
                        return '$0'
                    }
                },
                style: {
                    color: '#000000',
                    fontWeight: 'bold',
                    fontSize: '1em'
                },
                distance: 5
            },
            startOnTick: true,
            endOnTick: true,
            tickInterval: tickInterval
        },
        tooltip: {
            shared: true,
            formatter: function () {
                if (!this.points || !this.x) return false;
                let tooltipHtml = `<b>${this.x}</b><br/>`; // Add category (x-axis label)
                this.points.forEach(point => {
                    let value = point.y >= 0 ? ` $${Highcharts.numberFormat(point.y, 0, '.', ',')}` : ` -$${Highcharts.numberFormat(Math.abs(point.y), 0, '.', ',')}`;
                    tooltipHtml += `
                    <span style="color:${point.color}">\u25CF</span> 
                    ${point.series.name}: <b>${value}</b><br/>
                    `;
                });
                return tooltipHtml;
            },
            style: { fontSize: '11px' },
        },
        legend: {
            align: 'center',
            verticalAlign: 'bottom',
            layout: 'horizontal',
            width: '100%',
            padding: 4,
            backgroundColor: '#ffffff',
            symbolRadius: 0,
            symbolPadding: 2,
            itemDistance: 5,
            itemStyle: {
                color: '#000000',
                fontWeight: 'bold',
                fontSize: '0.9em',
                lineHeight: 1
            }
        },
        plotOptions: {
            column: {
                grouping: true,
                dataLabels: {
                    enabled: false,
                    inside: false,
                    crop: false,
                    overflow: 'none',
                    padding: 4,
                },
                borderRadius: {
                    radius: '0%',
                },
                pointWidth: 10
            },
        },
        series: youData
    }
}

export { premiumChart, netPremiumWrittenToSurplus, netLeverageRatio, reinsuranceToGPW, liquidityRatio, combinedRatio, opexRatio, breakEvenRatio, surplusToGRIF000s }